var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NotificationsPage"},[_c('LLPage',{staticClass:"Dashboard",scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('LLBreadCrumbs',{attrs:{"crumbs":_vm.crumbs}})]},proxy:true},{key:"content",fn:function(){return [_c('UploadProgress'),_c('notifications-page-content')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }